import React, { Fragment, useEffect, useLayoutEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { SvgIconHandler } from "../svg-icon-hadler";

import "./carousel.m.css";
import Headline from "../Headline";

const YoutubeFeedCard = ({ item, getCurrentCard, sectionSlug }) => {
  return (
    <div styleName="card" data-test="card" onClick={() => getCurrentCard(item)}>
      <div styleName="img-container">
        <img src={item?.thumbnail} alt={item?.title} />
        <div styleName="icon-container">
          <SvgIconHandler type="play-arrow" width="25px" height="25px" />
        </div>
      </div>
      <Headline styleName="title" headline={item?.title} sectionSlug={sectionSlug} />
    </div>
  );
};

const Carousel = ({ feedItems = [], getCurrentCard = () => {}, sectionSlug }) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [disableLeftArrow, setDisableLeftArrow] = useState(true);
  const [disableRightArrow, setDisableRightArrow] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const containerRef = useRef(null);

  const handleLeftArrowClick = () => {
    if (containerRef.current) {
      const containerWidth = containerRef?.current?.getBoundingClientRect()?.width;
      const newScrollPosition = scrollPosition - containerWidth;
      setScrollPosition(newScrollPosition);
    }
  };

  const handleRightArrowClick = () => {
    if (containerRef.current) {
      const containerWidth = containerRef?.current?.getBoundingClientRect()?.width;
      const newScrollPosition = scrollPosition + containerWidth;
      setScrollPosition(newScrollPosition);
    }
  };

  useLayoutEffect(() => {
    const containerWidth = containerRef?.current?.getBoundingClientRect()?.width;
    if (scrollPosition + containerWidth >= containerWidth * feedItems?.length) {
      setDisableRightArrow(true);
    } else {
      setDisableRightArrow(false);
    }

    if (scrollPosition > 0) {
      setDisableLeftArrow(false);
    } else {
      setDisableLeftArrow(true);
    }
  }, [scrollPosition, feedItems.length]);

  const resetScrollPosition = () => {
    setScrollPosition(0);
    setDisableLeftArrow(true);
  };

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window?.innerWidth;
      if (newWidth !== windowWidth) {
        setWindowWidth(newWidth);
        resetScrollPosition();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [windowWidth]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setWindowWidth(window.innerWidth);
    }
  }, []);
  return (
    <div className="container" styleName="carousel-container">
      <div styleName="top-row">
        <h1 styleName="heading">Up Next</h1>
        <div styleName="btns">
          {!disableLeftArrow && (
            <button styleName="prev" aria-label="Previous slide" onClick={handleLeftArrowClick}>
              <SvgIconHandler type="arrow" width="40px" height="40px" />
            </button>
          )}
          {!disableRightArrow && (
            <button styleName="next" aria-label="Next slide" onClick={handleRightArrowClick}>
              <SvgIconHandler type="arrow" width="40px" height="40px" />
            </button>
          )}
        </div>
      </div>

      <div styleName="carousel" ref={containerRef}>
        {feedItems?.map((item, index) => {
          return (
            <div
              styleName="cards-container"
              key={index}
              style={{ transform: `translateX(-${scrollPosition}px)`, transition: "transform 0.5s ease-in-out" }}
            >
              {item.map((element, count) => {
                return (
                  <Fragment key={`${index}-${count}`}>
                    {element?.title && (
                      <YoutubeFeedCard item={element} getCurrentCard={getCurrentCard} sectionSlug={sectionSlug} />
                    )}
                    {element?.title && count < item?.length - 1 && <div styleName="divider"></div>}
                  </Fragment>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

Carousel.propTypes = {
  feedItems: PropTypes.array.isRequired,
  getCurrentCard: PropTypes.func.isRequired,
  sectionSlug: PropTypes.string,
};

export default Carousel;
